import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {environment} from 'src/environments/environment';
import {ContentLanguageMetadata} from 'src/app/model/content-language-metadata.model';

@Injectable({
  providedIn: 'root',
})
export class ContentLanguageMetadataService {
  readonly langMetadataApiUlr = environment.endPoint + ApplicationPackage.CMS_VOD + Service.MULTI_LANG;

  constructor(private http: HttpClient) {}

  getAllContentLangMetadata(metadataId: number): Observable<ContentLanguageMetadata[]> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (metadataId) {
      queryParams = queryParams.set('metadataId', <any>metadataId);
    }
    return this.http.get<ContentLanguageMetadata[]>(this.langMetadataApiUlr, {params: queryParams});
  }

  getById(metadataId: number): Observable<ContentLanguageMetadata> {
    return this.http.get<ContentLanguageMetadata>(this.langMetadataApiUlr + `/${metadataId}`);
  }

  addContentLanguageMetadata(cntLangMetadata: ContentLanguageMetadata, createChilds: boolean): Observable<ContentLanguageMetadata> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (createChilds) {
      queryParams = queryParams.set('createChilds', <any>createChilds);
    }
    return this.http.post<any>(this.langMetadataApiUlr, cntLangMetadata, {params: queryParams});
  }

  editContentLanguageMetadata(
    contentLangMetadata: ContentLanguageMetadata,
    updateChils: boolean,
  ): Observable<ContentLanguageMetadata> {
    let queryParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (updateChils) {
      queryParams = queryParams.set('updateChilds', <any>updateChils);
    }
    return this.http.put<ContentLanguageMetadata>(this.langMetadataApiUlr, contentLangMetadata, {params: queryParams});
  }

  deleteContentLanguageMetadata(id: number): Observable<ContentLanguageMetadata> {
    return this.http.delete(this.langMetadataApiUlr + `/${id}`);
  }
}
